export default (store) => {
  if (localStorage.getItem("vsAnalyticsLocale")) return localStorage.getItem("vsAnalyticsLocale");

  switch (store.region) {
    case "ja":
      return "ja";
    case "ko":
      return "ko";
    default:
      return "en";
  }
};
